export enum TipoMetrica {
    PorQuantidade = 1,
    PorValor = 2,
    PorCupom = 3
}
